module.exports = __webpack_public_path__ + "img/carMockLitemin.d1e7b260.jpg";